import React, { useEffect, useState } from 'react';
import avnetabacus from "src/assets/images/Avnet_abacus.svg";
import avnetslica from "src/assets/images/Avnet_silica.svg";
import ebv from "src/assets/images/EBV.svg";
import System from 'src/helper/system';
import { useAuthStore } from 'src/hooks/auth';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const UserReverification = () => {
  const token = System.getParams().token;
  const [{ }, { get_user_verification }, { }] = useAuthStore();
  const [valid, setValid] = useState(false);
  const [__check] = useAxiosIndicatorCheck();

  useEffect(() => {
    const validateUserReverification = async () => {
      let res = await get_user_verification(token);
      if (res?.isSuccessFull) {
        setValid(true);
      }
    }
    if (token) {
      validateUserReverification();
    }
    else {
      window.location.href = System.getHomepageUrl()
    }
  }, [])
  return (
    <div className='user-reverification'>
      <div className='mb-5 user-reverification-banner position-relative'>
        <div className='container '>
          <h2>New Journey in Design</h2>
        </div>
      </div>
      <div className='container mb-4'>
        <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
          <div className="page-title font-oswald font-light font-38 mb-3 text-darkgreen">Re-Verification</div>
        </div>
        <div>
          {__check(['USER_VERIFICATION_API_CALL']).render}
        </div>
        {!__check(['USER_VERIFICATION_API_CALL']).status &&
          <React.Fragment>
            <p>{valid ? 'Your Email ID has been successfully verified.' : 'Link is expired please contact help Desk.'}</p>
            <div className='mt-4'>
              {!valid &&
                <>
                  <p>Reach Avnet EMEA Online Support Team at:</p>
                  <div className='d-flex align-items-center'>
                    <i className="fa fa-phone me-2 text-black" aria-hidden="true"></i>
                    00800 412 412 11
                  </div>
                  <div className='d-flex align-items-center'>
                    <a href="mailto:OnlineSupportEU@avnet.com" className='bs5 text-decoration-underline text-black'>
                      <i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i>
                      OnlineSupportEU@avnet.com
                    </a>
                  </div>
                </>
              }
              <hr className='border-dark-gray'></hr>
            </div>
          </React.Fragment>
        }

        <div className='select-destiny'>
          <div className='text-center'>
            <h2 className='font-oswald font-light font-30 mt-5 mb-5 text-black'>Select Your Destination</h2>

            <div className='destiny-box-container'>
              <div className='row'>
                <div className='col-md-4 mb-2'>
                  <div className='text-center destiny-box '>
                    <img src={avnetabacus} className="mb-4" />
                    <a href={System.getSpeedboatURL('abacus')} className='font-arial font-16 text-darkgreen d-block'><b> Enter Avnet Abacus</b></a>
                  </div>
                </div>
                <div className='col-md-4 mb-2'>
                  <div className='text-center destiny-box '>
                    <img src={ebv} className="mb-4" />
                    <a href={System.getSpeedboatURL('ebv')} className='font-arial font-16 text-darkgreen d-block'><b> Enter EBV Elektronik</b></a>
                  </div>
                </div>
                <div className='col-md-4 mb-2'>
                  <div className='text-center destiny-box '>
                    <img src={avnetslica} className="mb-4" />
                    <a href={System.getSpeedboatURL('silica')} className='font-arial font-16 text-darkgreen d-block'><b> Enter Avnet Silica</b></a>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>


  )
}

export default UserReverification